module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_f_erythristic.a953acb6.png";